/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';
import { APPS_COMPONENT_ID } from '../../utils/enums';
import LoggerUtil from '../../utils/LoggerUtil';
import BannerAnalytics from '../../analytics/bannerAnalytics';

const COMPONENT_ID = 'BannerComponent';

export default observer(({
    appConfig, appsSkeletonModel, banner, bannerLayouts, allAppsModel,
}) => {
    if (!bannerLayouts) {
        LoggerUtil.warn(`${APPS_COMPONENT_ID}: ${COMPONENT_ID}: Banner layouts not found!`);
    }

    const bannerAnalyticsCallback = BannerAnalytics.bannerAnalyticsCallback.bind(BannerAnalytics);
    if (banner && bannerLayouts) {
        const {
            layoutId,
            bannerItemList,
        } = banner;
        const BannerLayout = bannerLayouts.banner[layoutId];
        if (BannerLayout) {
            return (
                <BannerLayout
                    appConfig={appConfig}
                    appsSkeletonModel={appsSkeletonModel}
                    allAppsModel={allAppsModel}
                    bannerItemLayouts={bannerLayouts.bannerItem}
                    bannerItems={bannerItemList}
                    bannerAnalyticsCallback={bannerAnalyticsCallback}
                    bannerSectionId={BannerAnalytics.getSectionId()}
                    bannerPlatform={BannerAnalytics.getPlatform()} />
            );
        }
    }
    return null;
});
